import request from '@/utils/request'

// 查询设备耗材列表
export function listEquipmentConsumables(query) {
  return request({
    url: '/system/equipment-consumables/list',
    method: 'get',
    params: query,
  })
}

// 查询设备耗材分页
export function pageEquipmentConsumables(query) {
  return request({
    url: '/system/equipment-consumables/page',
    method: 'get',
    params: query,
  })
}

// 查询设备耗材详细
export function getEquipmentConsumables(data) {
  return request({
    url: '/system/equipment-consumables/detail',
    method: 'get',
    params: data,
  })
}

// 新增设备耗材
export function addEquipmentConsumables(data) {
  return request({
    url: '/system/equipment-consumables/add',
    method: 'post',
    data: data,
  })
}

// 修改设备耗材
export function updateEquipmentConsumables(data) {
  return request({
    url: '/system/equipment-consumables/edit',
    method: 'post',
    data: data,
  })
}

// 删除设备耗材
export function delEquipmentConsumables(data) {
  return request({
    url: '/system/equipment-consumables/delete',
    method: 'post',
    data: data,
  })
}
